import { Navigate, useLocation } from 'react-router-dom';

import Page404 from 'containers/Page404/Page404';
import { routePaths } from 'global/routePaths';
import { useParamsQuery } from 'hooks/common/useParamsQuery';
import tokenService from 'utils/token';

import AcceptedShift from './AcceptedShift';
import DeclinedShift from './DeclinedShift';

const Shift = () => {
  const search = useLocation().search;
  const searchQuery = useParamsQuery();

  const action = searchQuery.get('action');

  if (action === 'accepted') {
    return <AcceptedShift />;
  }

  if (action === 'declined') {
    return <DeclinedShift />;
  }

  if (action === 'pick') {
    if (!tokenService.getAccessToken() || tokenService.getAccessToken() === 'undefined') {
      return <Navigate to={`${routePaths.auth.login}${search}`} replace />;
    } else {
      return <Navigate to={`${routePaths.cherryPickShift.base.route}${search}`} replace />;
    }
  }

  return <Page404 />;
};

export default Shift;
